module.exports = __webpack_public_path__ + "img/audio.34f4d778.svg";